import request from '@/request'

export function changeRole(typeCode) {
  return request({
    url: `/userRole/changeRole?roleCode=${typeCode}`,
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/userRole.js